import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import MUISelect from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { navigate } from 'gatsby';

class VersionSwitcher extends React.Component {
    handleChange = (event) => {
        navigate(event.target.value);
    };

    render() {
        const { versions, current } = this.props;

        let menuItems = [];

        for (let i = 0; i < versions.length; i++) {
            menuItems.push(
                <MenuItem value={versions[i].node.frontmatter.path}>{versions[i].node.frontmatter.version}</MenuItem>
            );
        }

        return (
            <div align="right">
                <Typography variant="caption" className="versionLabel">
                    {' '}
                    Version
                </Typography>
                <MUISelect
                    disableUnderline={true}
                    onChange={this.handleChange}
                    value={current}
                    autoWidth
                    MenuProps={{
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                        },
                        getContentAnchorEl: null,
                        PaperProps: {
                            square: true,
                        },
                    }}
                >
                    {menuItems}
                </MUISelect>
            </div>
        );
    }
}

VersionSwitcher.propTypes = {
    versions: PropTypes.object.isRequired,
    current: PropTypes.object.isRequired,
};

export default VersionSwitcher;
